
export default {
    name: 'WelcomePageModule',
    template: '#cmp-welcome',
    data() {
        return {
            language: 'en-us',
            notifications: []
        };
    },
    computed: {
        showNotifications() {
            $('[data-toggle=tooltip]').tooltip();
            return this.notifications.length > 0;
        }
    },
    methods: {
        getNotifications() {
            let self = this;
            $.getJSON('/api/notifications')
                .done((r) => {
                    self.language = r.language;
                    if (r.notifications.length > 0) {
                        self.getNotificationContent(r.notifications);
                    }
                    
                });
        },
        getNotificationContent(notifications) {
            let self = this;

            notifications.forEach((n) => {
                let content;

                n.content.forEach((c) => {
                    if (c.locale === self.language) {
                        content = c;
                    }
                });

                if (!content) {
                    n.content.forEach((c) => {
                        if (c.locale === 'en-us') {
                            content = c;
                        }
                    });
                }

                if (!content) {
                    content = n.content[0];
                }

                content.guid = n.header.guid;
                //$('[data-toggle=tooltip]').tooltip();
                self.notifications.push(content);
            });
            $('[data-toggle=tooltip]').tooltip();
        },
        viewNotification(n) {
            $('[data-toggle=tooltip]').tooltip();
            this.$router.push({ name: 'notificationDetails', params: { guid: n.guid } });
        },
    },
    created() {
        let self = this;
        toggleRegisterLoginMsg(true);
        window.setTimeout(function () {
            self.getNotifications();
        }, 900);
    }
}


// WEBPACK FOOTER //
// ./src/scripts/vue/components/Welcome.js